// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"bda1dd24","695":"7c541554"}[chunkId] + ".chunk.css";
};